import { render, staticRenderFns } from "./orders-echart.vue?vue&type=template&id=37b925b8&scoped=true&"
import script from "./orders-echart.vue?vue&type=script&lang=js&"
export * from "./orders-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b925b8",
  null
  
)

export default component.exports